<template>
  <div ref="fristhome">
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->
      <el-form
        :inline="true"
        :model="searchForm"
        :rules="searchRules"
        ref="searchForRef"
        autocomplete="on"
        size="mini"
      >
        <!-- 面包屑导航 -->
        <!--              <el-form-item>-->
        <!--              <el-link href="/Welcome">首页</el-link>-->
        <!--              <span> > 系统保险列表</span>-->
        <!--              </el-form-item>-->
        <el-form-item label="签单开始时间" size="small" label-width="100px">
          <el-date-picker v-model="searchForm.start_time" type="date" placeholder="请选择开始时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="签单结束时间" size="small" label-width="100px">
          <el-date-picker v-model="searchForm.end_time" type="date" placeholder="请选择开始时间"></el-date-picker>
        </el-form-item>
        <shopCompanyTemp ref="shopCompanyTemp" @changeData="setshopId"></shopCompanyTemp>
        <!--运输公司筛选-->
        <el-form-item label="保司" label-width="70px">
          <el-select v-model="searchForm.corp_id" filterable clearable placeholder="请选择保司">
            <el-option v-for="item in corpData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保单号" label-width="70px">
          <el-input v-model="searchForm.proposal_form" placeholder="请输入保单号" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item label="投保单号" label-width="70px">
          <el-input v-model="searchForm.policy_no" placeholder="请输入投保单号" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item label="订单状态" label-width="70px">
          <el-select
            class="inputWidth100"
            v-model="searchForm.status"
            filterable
            clearable
            placeholder="请选择订单状态"
          >
            <el-option
              v-for="item in orderstatus"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="险种" label-width="70px">
          <el-select
            class="inputWidth100"
            v-model="searchForm.product_id"
            filterable
            clearable
            placeholder="请选择险种"
          >
            <el-option
              v-for="(item,index) in pList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="车牌" label-width="70px">
          <el-input v-model="searchForm.plate_number" placeholder="请输入车牌号" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item label="车架号" label-width="70px">
          <el-input v-model="searchForm.vin" placeholder="请输入车架号" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="searchSubmit()">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-tooltip class="item" effect="dark" content="条件：同投保人同保司不同车辆的保险单" placement="top-start">
            <el-button size="mini" type="primary" @click="goPayPublic">对公支付</el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-tooltip class="item" effect="dark" content="条件：选择待支付订单" placement="top-start">
            <el-button size="mini" type="warning" @click="goPay">净费支付</el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-tooltip
            content="条件:仅支持中路 同渠道同投保人不同车辆 "
            class="item"
            placement="top-start"
            effect="dark"
          >
            <el-button type="success" size="small" @click="clickDialog1()">中路对公扫码</el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-button @click="toExcel()">导出Excel</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="toPrint()">打印</el-button>
        </el-form-item>
      </el-form>
      <!-- 车辆列表 -->

      <div id="printFrom">
        <!--        统计数据-->
        <div>
          <el-tag>已选：{{clickPayNum }}</el-tag>
          <el-tag type="success">共计保费：{{ clickRealPrice }}</el-tag>
          <el-tag type="info">共计实际支出：{{ clickPrice }}</el-tag>
          <el-tag type="warning">共计利润：{{ clickProfit }}</el-tag>

          <el-dropdown split-button type="primary" size="small">
            共计车主：{{ clickCarOwners }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in CarOwnersData" :key="item">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown split-button type="primary" size="small">
            所有人(运输公司)：{{ clickCarPerson }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in CarPersonData" :key="item">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- 保险列表 -->
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          height="400"
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" width="60"></el-table-column>
          <el-table-column label="车牌号" width="90" prop="plate_number" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="车架号" width="70px" prop="vin" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="车主" width="60px" prop="username" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column
            label="保险名称"
            width="70"
            prop="product_name"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="保司" width="100" prop="corp_name" :show-overflow-tooltip="true"></el-table-column>

          <el-table-column label="保险金额" width="80" prop="real_price" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="保险净费" width="80" prop="sell_price" :show-overflow-tooltip="true"></el-table-column>

          <!--                <el-table-column-->
          <!--                        label="保险客服"-->
          <!--                        width="105"-->
          <!--                        prop="corp_tel"-->
          <!--                        :show-overflow-tooltip='true'>-->
          <!--                </el-table-column>-->
          <el-table-column label="投保人" width="120" prop="owner_name" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column width="120" label="被投保人" prop="allPerson" :show-overflow-tooltip="true"></el-table-column>

          <el-table-column label="签单日期" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.effective_date | dateFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="保险起期" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.start_time | dateFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="保险止期" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.end_time | dateFormat }}</span>
            </template>
          </el-table-column>

          <el-table-column label="订单状态" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">{{ scope.row.status | statusFilter }}</template>
          </el-table-column>

          <el-table-column label="下发备注" prop="audit_remark"></el-table-column>
          <el-table-column label="出单员" width="105" prop="issuer_name" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="凭证流水号" width="105" prop="pay_sn" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="支付凭证图片" width="110px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span
                @click="handelDialog(scope.row.pay_sn_url)"
                v-if="scope.row.pay_sn_url"
                style="color: #3a8ee6"
              >查看</span>
              <span v-else>暂无</span>
            </template>
          </el-table-column>
          <el-table-column label="支付二维码" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.qr_code_status==2">
                <viewer>
                  <span>
                    <img :src="scope.row.qr_code" min-width="20" height="20" />
                  </span>
                </viewer>
                <el-link type="success" @click="gain(scope.row)">重新获取</el-link>
              </div>
              <div v-if="scope.row.qr_code_status==-1">未申请</div>
              <div v-if="scope.row.qr_code_status==0">未执行</div>
              <div v-if="scope.row.qr_code_status==1">获取中</div>
              <el-link
                v-if="scope.row.qr_code_status==2"
                type="success"
                @click="gain(scope.row)"
              >重新获取</el-link>
              <el-link
                v-if="scope.row.qr_code_status==3"
                type="success"
                @click="gain(scope.row)"
              >重新获取</el-link>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="290px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <!--                    电子签章open-->
              <span v-if="scope.row.esign_file && scope.row.esign_template">
                <el-button
                  v-if="scope.row.esign_file.signFlowStatus==2"
                  type="primary"
                  size="mini"
                  @click="checkfile(scope.row,2)"
                >查看投保单</el-button>
                <el-button
                  v-if="arr.includes(scope.row.esign_file.signFlowStatus)"
                  type="primary"
                  size="mini"
                  @click="checkfile(scope.row,2)"
                >签署投保单</el-button>

                <span v-if="scope.row.status==6&&scope.row.esign_file.signFlowStatus==3">请直接去支付</span>

                <span v-if="scope.row.status ==7">
                  <el-button type="warning" size="mini" @click="handelEdit(scope.row)">订单 修改 / 取消</el-button>
                </span>
              </span>

              <span v-else>
                <span v-if="scope.row.status==6">请直接去支付</span>
                <span v-if="scope.row.status!=6 && scope.row.status!=7 ">不需要签章</span>
                <span v-if="scope.row.status ==7 ">
                  <el-button type="warning" size="mini" @click="handelEdit(scope.row)">订单 修改 / 取消</el-button>
                </span>
              </span>
              <!--                    电子签章 end -->
              <span v-if="scope.row.policy_no_pdf_url">
                <el-button
                  v-if="scope.row.policy_no_pdf_url"
                  type="success"
                  size="mini"
                  @click="dowfile(scope.row)"
                >保单下载</el-button>
                <el-button
                  v-if="scope.row.policy_no_pdf_url"
                  type="primary"
                  size="mini"
                  @click="goDoc(scope.row)"
                >保单查看</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" center :visible.sync="dialogFormVisible" width="996px">
      <el-tabs type="border-card">
        <el-tab-pane label="订单修改">
          <div>
            <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="100px">
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="主车牌号">
                    <el-input
                      v-model="form.plate_number"
                      prefix-icon="el-icon-search"
                      @click.native.prevent="chooseCar"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="车辆类型">
                    <el-input type="text" v-model="form.vehicle_type"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="车架号" prop="remark">
                    <el-input v-model="form.vin" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="投保人" prop="toubao_name">
                    <el-input v-model="form.toubao_name" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="投保人证件" prop="toubao_idcard">
                    <el-input v-model="form.toubao_idcard" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="投保人电话">
                    <el-input autocomplete="off" v-model="form.toubao_mobile" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="被保险人">
                    <el-input v-model="form.owner_name" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="被保险人证件" prop="owner_idcard">
                    <el-input v-model="form.owner_idcard" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="被保险人电话" autocomplete="off" prop="owner_mobile">
                    <el-input v-model="form.owner_mobile" />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="签单日期">
                    <el-date-picker
                      v-model="form.effective_date"
                      type="datetime"
                      placeholder="选择日期"
                      class="inputWidth185"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="保险起期" prop="owner_idcard">
                    <el-date-picker
                      v-model="form.start_time"
                      type="datetime"
                      placeholder="选择日期"
                      class="inputWidth185"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="保险止期" prop="owner_mobile">
                    <el-date-picker
                      v-model="form.end_time"
                      type="datetime"
                      placeholder="选择日期"
                      class="inputWidth185"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="reset_dialogForm('form')">取 消</el-button>
              <el-button type="primary" @click="submitForm('form')">确 定</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="订单取消">
          <el-button type="danger" @click="reset_order('form')">取消订单</el-button>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog
      title="支付凭证图片"
      center
      :visible.sync="uploadDialog"
      top="15%"
      width="30%"
      append-to-body
    >
      <viewer v-if="uploadImg" style="z-index: 9999">
        <span>
          <img :src="uploadImg" width="300px" height="300px" />
        </span>
      </viewer>
    </el-dialog>

    <el-dialog :visible.sync="fileOrder" width="100%" ref="tk">
      <el-row :gutter="24">
        <el-col
          :span="24"
          :offset="20"
          style="width: 100%; margin: 0 auto; height: 40px; margin-top:20px; text-align: right; position: fixed; top: 300px;right:50px;"
        >
          <el-button type="warning" @click="fileOrder=false">关闭保单</el-button>
        </el-col>
      </el-row>
      <template>
        <iframe :src="fileUrl" class="tableClass" width="100%" height="100%"></iframe>
      </template>
    </el-dialog>
    <ePay
      :payVisibleProp.sync="isShowPay"
      :orderInfoProp.sync="multipleSelectionM"
      :collectionPayinfo.sync="collectionPay"
      :isShow="isShow"
      :titleName="titleName"
      v-on:eventPay="choosePay"
    />
    <!--:orderInfoProp="multipleSelection"-->
    <eCar :carVisibleProp.sync="isShowCar" v-on:eventCar="chooseCarInfo" />
  </div>
</template>

<script>
import table2excel from "js-table2excel";
import print from "print-js";
//import eTable from "../common/eTable.vue";
import moment from "moment"; //日期时间转换
//import eInsurance from "../common/eInsurance";
import ePay from "../common/ePay";
import shopCompanyTemp from "../common/shopCompanyTemp.vue";
import carListTemp from "../common/carlistTemp.vue";
import eCar from "../common/eCar";
import Watermark from "../../utils/waterMark";
import config from "../../utils/utils/config";
import { formatOrderStatus, orderStatus } from "../../utils/utils/index";
export default {
  name: "insuranceSysTeamOrder",
  components: {
    //eTable,
    //eInsurance,
    ePay,
    shopCompanyTemp,
    carListTemp,
    eCar,
  },
  props: {},
  data() {
    return {
      isShowPay: false,
      fileOrder: false,
      fileUrl: "",
      shopList: [],
      corpData: [],
      arr: [0, 1],
      arrall: [0, 1, 2],
      isShowCar: false,
      // 搜索
      searchForm: {
        shop_id: "",
        status: "",
        plate_number: "",
        start_time: "",
        end_time: "",
        proposal_form: "",
        product_id: "",
        vin: "",
      },
      searchRules: {
        name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
      },
      orderstatus: [],
      // 数据
      tableLoadData: [],
      collectionPay: {},
      limit: 10,
      page: 1, // 当前页码
      total: 0, //总条目数
      id: "",
      rules: {
        plate_number: [
          { required: true, message: "请输入车牌", trigger: "blur" },
        ],
      },
      dialogFormVisible: false,
      title: "",
      form: {
        order_id: "",
        car_id: "", //车辆ID
        shop_id: "", //投保人ID
        owner_id: "", //被投保人ID
        owner_name: "", //被投保人姓名
        owner_idcard: "", //被投保人证件号码
        owner_mobile: "", //被投保人手机号
        toubao_name: "", //投保人姓名
        toubao_idcard: "", //投保人证件号码
        toubao_mobile: "", //投保人身份证号
        effective_date: "", //签单日期
        start_time: "", //保险起期
        end_time: "", //保险结束日期
        vehicle_type: "",
        vin: "",
        plate_number: "",
      },
      uploadImg: "",
      uploadDialog: false,
      multipleSelectionM: {},
      //统计数据open
      clickPayNum: 0,
      clickRealPrice: 0,
      clickPrice: 0,
      clickProfit: 0,
      clickCarOwners: 0,
      clickCarPerson: 0,
      CarOwnersData: [],
      CarPersonData: [],
      pList: [],
      //统计数据end
      isShow:false,
      titleName:'',
    };
  },
  created() {
    this.orderstatus = orderStatus();
    this.collectionPay = sessionStorage.getItem("feePayInfo");
    this.DataList();
    this.corpList();
    this.getProductList();
    let str =
      sessionStorage.getItem("userName") +
      " " +
      moment().format("yyyy-MM-DD HH:mm:ss");
    this.$nextTick(() => {
      //要加载完才能获取$refs
      Watermark.set(str, this.$refs.fristhome);
    });
  },
  mounted() {},
  filters: {
    //必需
    statusFilter(status) {
      return formatOrderStatus(status);
    },
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time * 1000).format("yyyy-MM-DD HH:mm:ss");
    },
  },
  methods: {
    areObjectsPropsEqual(arr, prop) {
      return arr.every(
        (obj, index, self) => index === 0 || obj[prop] === self[index - 1][prop]
      );
    },
    clickDialog1() {
      
      let revlue = config.setScan(this.multipleSelection);
      ////console.log('rev',revlue)
      if (revlue.orderIDs && revlue.total_money) {
        this.$set(this.multipleSelectionM, "total_money", revlue.total_money);
        this.$set(this.multipleSelectionM, "orderIDs", revlue.orderIDs);
        this.titleName='全额保费'
        this.isShow=true
        this.isShowPay = true;
      } else if (revlue.message) {
        this.$message.error(revlue.message);
      }
    },
    gain(row) {
      const param = {
        order_id: row.order_id,
        access_token: sessionStorage.getItem("token"),
      };
      this.$axios
        .getagain(param)
        .then((res) => {
          if (res.code == 200) {
            // this.searchSubmit(3)
          }
        })
        .catch(function (error) {});
    },
    //获取险种
    getProductList() {
      var param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        pageNum: 1,
        pageSize: 100,
      };
      this.$axios.insuranceProdcutList(param).then((res) => {
        if (res.code == 200) {
          this.pList = res.data.data;
        }
        // console.log('productNameList',res.data.data);
      });
    },
    chooseCar() {
      this.isShowCar = true;
    },
    corpList() {
      const param = {
        queryParams: this.searchForm.name,
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        page: 1,
        pageSize: 30,
      };
      this.$axios
        .corpList(param)
        .then((res) => {
          if (res.code == 200) {
            this.corpData = res.data.data;
            //this.total = res.data.total
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    //生成合同链接 createFileByOrder
    fileByOrder(orderId) {
      console.log("fileByOrder", orderId);
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        order_id: orderId,
      };
      this.$axios
        .createFileByOrder(param)
        .then((res) => {
          if (res.code == 200) {
            //console.log(res)
            this.fileOrder = true;
            this.fileUrl = res.data.shortUrl;
            //window.open(res.data.shortUrl)
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    //生成查看合同链接 getFileSignUrl
    fileSignUrl(tsignFlowId) {
      console.log("fileSignUrl", tsignFlowId);
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        signFlowId: tsignFlowId,
      };
      this.$axios
        .getFileSignUrl(param)
        .then((res) => {
          if (res.code == 200) {
            console.log("getFileSignUrl", res);
            this.fileOrder = true;
            this.fileUrl = res.data.shortUrl;
            //window.open(res.data.shortUrl)
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    checkfile(row, type = 1) {
      this.$refs.tk.$el.firstChild.style.height = "100%";
      if (type == 1) {
        //生成
        this.fileByOrder(row.order_id);
      } else {
        // 查看
        //console.log(row.esign_file.signFlowId)
        this.fileSignUrl(row.esign_file.signFlowId);
      }
    },
    dowfile(row) {
      window.open(row.policy_no_pdf_url);
    },
    goDoc(row) {
      ////console.log(row)
      if (row.policy_no_pdf_url) {
        return new Promise((resolve, reject) => {
          let blob = null;
          let xhr = new XMLHttpRequest();
          xhr.open("GET", row.policy_no_pdf_url); //http://101.34.220.192:9000/emergency-response/integration/system_manual/RESOURCE1689663612812.pdf
          xhr.responseType = "blob";
          xhr.onload = () => {
            blob = xhr.response;
            const blobob = new Blob([blob], {
              type: "application/pdf;charset=utf-8",
            });
            const href = window.URL.createObjectURL(blobob);
            window.open(href, "newWindow");
            resolve(file);
          };
          xhr.onerror = (e) => {
            reject(e);
          };
          xhr.send();
        });
      } else {
        alert("暂无文件");
      }
    },
    statusFilter2(status) {
      return formatOrderStatus(status);
    },
    openWin(url) {
      var name; //网页名称，可为空;
      var iWidth = 500; //弹出窗口的宽度;
      var iHeight = 570; //弹出窗口的高度;
      //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
      var iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
      window.open(
        url,
        name,
        "height=" +
          iHeight +
          ",innerHeight=" +
          iHeight +
          ",width=" +
          iWidth +
          ",innerWidth=" +
          iWidth +
          ",top=" +
          iTop +
          ",left=" +
          iLeft +
          ",toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no"
      );
    },
    setshopId(value) {
      //this.form.plate_number = value
      this.searchForm.shop_id = value;
    },
    getTime(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },
    goPayPublic() {
      //if(this.multipleSelection)
      //{
      let revlue = config.setmultipleSelection(this.multipleSelection);
      //如果选择了订单，要组成order_id 传给payPublic 页面
      if (revlue.orderIDs) {
        let orderIdsV = JSON.stringify(revlue.orderIDs);
        this.$router.push({
          path: "/payPublic",
          query: { orderids: orderIdsV },
        });
      } else if (revlue.message) {
        this.$message.error(revlue.message);
      }
      //}else{
      //  this.$router.push('/payPublic');
      //}
    },
    choosePay() {
      this.isShowPay = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // 计算选择的订单的金额
      let priceSum = 0.0; // 保费
      let sellPriceSum = 0.0; // 净费
      let profitPriceSum = 0.0; //利润

      val.forEach((item) => {
        sellPriceSum += parseFloat(item.sell_price);
        priceSum += parseFloat(item.real_price);
        profitPriceSum +=
          Math.round(
            (parseFloat(item.real_price) - parseFloat(item.sell_price)) * 100
          ) / 100;
      });

      this.clickPayNum = val.length + "个";
      this.clickRealPrice = Math.round(priceSum * 100) / 100 + "元";
      this.clickPrice = Math.round(sellPriceSum * 100) / 100 + "元";
      this.clickProfit = Math.round(profitPriceSum * 100) / 100 + "元";
      let uniqueAllPerson = new Set(
        val.filter((obj) => obj.username).map((obj) => obj.username)
      );
      let uniqueAllPersons = uniqueAllPerson.size;
      this.clickCarOwners = uniqueAllPersons + "个";
      this.CarOwnersData = uniqueAllPerson;
      // console.log(this.clickCarOwners, this.CarOwnersData);

      let uniqueOwnerName = new Set(
        val.filter((obj) => obj.allPerson).map((obj) => obj.allPerson)
      );
      let uniqueOwnerNames = uniqueOwnerName.size;
      this.clickCarPerson = uniqueOwnerNames + "个";
      this.CarPersonData = uniqueOwnerName;
    },
    goPay() {
      let revlue = config.setmultipleSelection(this.multipleSelection);
      ////console.log('rev',revlue)
      if (revlue.orderIDs && revlue.total_money) {
        this.$set(this.multipleSelectionM, "total_money", revlue.total_money);
        this.$set(this.multipleSelectionM, "orderIDs", revlue.orderIDs);
        this.titleName='净费支付'
        this.isShow=false

        this.isShowPay = true;
      } else if (revlue.message) {
        this.$message.error(revlue.message);
      }
    },
    handelCancel(row) {
      this.$confirm("请是否确认退保?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          if (action === "confirm") {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            //this.$refs.tb.clearSelection()
          } else {
            this.$message({
              message: "已取消操作",
              type: "warning",
            });
          }
        },
      });
    },
    //接收子组件传过来的值
    chooseCarInfo(car_number, ...params) {
      this.form.car_id = params[0]; //车辆ID
      this.form.shop_id = params[4]; //投保人ID
      this.form.owner_id = params[4];
      this.form.owner_name = params[2]; //被投保人姓名
      this.form.owner_idcard = params[5]; //被投保人证件号码
      this.form.owner_mobile = params[6]; //被投保人手机号
      this.form.toubao_name = params[2]; //投保人姓名
      this.form.toubao_idcard = params[5]; //投保人证件号码
      this.form.toubao_mobile = params[6]; //投保人身份证号
      this.form.vehicle_type = params[1]; //投保人身份证号
    },
    DataList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        status: "6,0,1,2,7,8,11",
        page: this.page,
        pageSize: this.limit,
      };
      if (this.searchForm.shop_id) param.shop_id = this.searchForm.shop_id;
      if (this.searchForm.status) param.status = this.searchForm.status;
      if (this.searchForm.plate_number)
        param.plate_number = this.searchForm.plate_number;
      if (this.searchForm.start_time)
        param.start_time = this.getTime(this.searchForm.start_time);
      if (this.searchForm.end_time)
        param.end_time = this.getTime(this.searchForm.end_time);
      if (this.searchForm.proposal_form)
        param.proposal_form = this.searchForm.proposal_form;
      if (this.searchForm.vin) param.vin = this.searchForm.vin;
      if (this.searchForm.product_id)
        param.product_id = this.searchForm.product_id;

      this.$axios
        .getInsuranceOrderList(param)
        .then((res) => {
          if (res.code == 200) {
            this.tableLoadData = res.data.data;
            this.total = res.data.total;
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize;
      this.DataList();
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.DataList();
    },
    // 新增
    addData() {
      this.$router.push("/insuranceAdd");
    },
    addByProduct() {
      this.$router.push("/insuranceAddByProduct");
    },
    addSysProduct() {
      this.$router.push("/insuranceSysProduct");
    },
    addSysCar() {
      this.$router.push("/insuranceSysCar");
    },
    handelEdit(row) {
      this.id = row.id;
      this.title =
        row.plate_number + " - " + row.allPerson + " - 订单 修改 / 取消 ";

      this.form.order_id = row.order_id ? row.order_id : "";
      this.form.toubao_name = row.allPerson ? row.allPerson : "";
      this.form.plate_number = row.plate_number ? row.plate_number : "";
      this.form.vin = row.vin ? row.vin : "";
      this.form.vehicle_type = row.vehicle_type ? row.vehicle_type : "";
      this.form.owner_name = row.owner_name ? row.owner_name : "";
      this.form.owner_idcard = row.owner_idcard ? row.owner_idcard : "";
      this.form.owner_mobile = row.owner_mobile ? row.owner_mobile : "";
      this.form.toubao_name = row.toubao_name ? row.toubao_name : "";
      this.form.toubao_idcard = row.toubao_idcard ? row.toubao_idcard : "";
      this.form.toubao_mobile = row.toubao_mobile ? row.toubao_mobile : "";
      this.form.effective_date = new Date(row.effective_date * 1000);
      this.form.start_time = new Date(row.start_time * 1000);
      this.form.end_time = new Date(row.end_time * 1000);

      this.dialogFormVisible = true;
    },
    reset_dialogForm(formName) {
      this.dialogFormVisible = false;
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },
    reset_order(formName) {
      if (this.form.order_id) {
        const param = {
          company_id: sessionStorage.getItem("company_id"),
          access_token: sessionStorage.getItem("token"),
          order_id: this.form.order_id,
        };
        this.$axios.cancelOrderInfo(param).then((res) => {
          if (res.code == 200) {
            this.DataList();
            this.$message.success(res.msg);
            this.dialogFormVisible = false;
            this.$router.push("/insuranceTeamOrder");
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("订单id 为空");
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            //car_id: this.$refs.carListTemp.form.car_id,//this.form.car_id,
            order_id: this.form.order_id,
            car_id: this.form.car_id, //车辆ID
            shop_id: this.form.shop_id, //投保人ID
            owner_id: this.form.owner_id, //被投保人ID
            owner_name: this.form.owner_name, //被投保人姓名
            owner_idcard: this.form.owner_idcard, //被投保人证件号码
            owner_mobile: this.form.owner_mobile, //被投保人手机号
            toubao_name: this.form.toubao_name, //投保人姓名
            toubao_idcard: this.form.toubao_idcard, //投保人证件号码
            toubao_mobile: this.form.toubao_mobile, //投保人身份证号
            vehicle_type: this.form.vehicle_type, //主车辆类型
            vin: this.form.vin, //主车辆类型
            plate_number: this.form.plate_number, //主车辆类型
            effective_date: this.getTime(this.form.effective_date), //签单日期
            start_time: this.getTime(this.form.start_time), //保险起期
            end_time: this.getTime(this.form.end_time), //保险结束日期
            company_id: sessionStorage.getItem("company_id"),
            access_token: sessionStorage.getItem("token"),
          };
          if (this.id) param.id = this.form.id;
          this.$axios.editOrderInfo(param).then((res) => {
            if (res.code == 200) {
              this.DataList();
              this.$message.success(res.msg);
              this.dialogFormVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    searchSubmit() {
      this.page = 1;
      this.DataList();
    },

    handelDel(e) {
      this.$confirm("此操作将删除该运输公司, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const param = {
            company_id: sessionStorage.getItem("company_id"),
            access_token: sessionStorage.getItem("token"),
            id: e.id,
          };
          //console.log(param);
          this.$axios
            .shopShopDel(param)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.DataList();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((error) => {
              //console.log(error);
            });
        })
        .catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: "info",
            message: "已取消删除",
          });
          this.DataList();
        });
      this.teamDialog = false;
    },
    // 点击弹出当前的图片
    handelDialog(index) {
      this.uploadDialog = true;
      // //console.log('handelDialog-index',index)
      this.uploadImg = index;
    },
    toPrint() {
      let params = {
        printable: "printFrom",
        header: "申请表",
        ignore: ["no-print"],
      };
      printJS({
        printable: params.printable, // 'printFrom', // 标签元素id
        type: params.type || "html",
        header: params.header, // '表单',
        targetStyles: ["*"],
        style: "@page {margin:0 10mm};", // 可选-打印时去掉眉页眉尾
        ignoreElements: params.ignore || [], // ['no-print']
        properties: params.properties || null,
      });
      // 打印指定页面
      // printJS('https://www.example.com/page');

      // 打印HTML字符串
      // printJS('<h1>Hello, PrintJS!</h1>');
      // printJS({printable: './static/img/login_bg.0899ffa.jpg', type: 'image', header: '销售单'});
    },
    //支持导出图片和类型转换
    toExcel() {
      const column = [
        {
          title: "车牌号码",
          key: "plate_number",
          type: "text",
        },
        {
          title: "车架号",
          key: "vin",
          type: "text",
        },
        {
          title: "车主",
          key: "username",
          type: "text",
        },
        {
          title: "保险名称",
          key: "product_name",
          type: "text",
        },
        {
          title: "保司",
          key: "corp_name",
          type: "text",
        },
        {
          title: "保险金额",
          key: "real_price",
          type: "text",
        },
        {
          title: "保险净费",
          key: "sell_price",
          type: "text",
        },
        {
          title: "保险客服",
          key: "corp_tel",
          type: "text",
        },
        {
          title: "投保人",
          key: "owner_name",
          type: "text",
        },
        {
          title: "被投保人",
          key: "allPerson",
          type: "text",
        },
        {
          title: "签单日期",
          key: "effective_date_format",
          type: "text",
        },
        {
          title: "保险起期",
          key: "start_time_format",
          type: "text",
        },
        {
          title: "保险止期",
          key: "end_time_format",
          type: "text",
        },
        {
          title: "出单员",
          key: "issuer_name",
          type: "text",
        },
        {
          title: "订单状态",
          key: "statusMsg",
          type: "text",
        },
        {
          title: "来源",
          key: "sourceMsg",
          type: "text",
        },
      ];
      //this.tableLoadData
      //let tableDatas = JSON.parse(JSON.stringify( res.data.data))
      for (var i in this.tableLoadData) {
        this.tableLoadData[i]["effective_date_format"] = this.getTime(
          this.tableLoadData[i]["effective_date"] * 1000
        );
        this.tableLoadData[i]["start_time_format"] = this.getTime(
          this.tableLoadData[i]["start_time"] * 1000
        );
        this.tableLoadData[i]["end_time_format"] = this.getTime(
          this.tableLoadData[i]["end_time"] * 1000
        );
        this.tableLoadData[i]["statusMsg"] = this.statusFilter2(
          this.tableLoadData[i]["status"]
        );
        this.tableLoadData[i]["sourceMsg"] = this.tableLoadData[i]["source"]
          ? "运输公司"
          : "平台";
        this.tableLoadData[i]["username"] = this.tableLoadData[i]["username"]
          ? this.tableLoadData[i]["username"]
          : "";
      }
      ////console.log(this.tableLoadData)
      table2excel(column, this.tableLoadData, "订单数据");
    },
  },
};
</script>

<style scoped lang="less">
.table_name {
  font-weight: bold;
  /* border: 1px solid #f00; */
}
.table_name:hover {
  color: #409eff;
  cursor: pointer;
}
.el-dialog__body {
  height: 100%;
}
.dialog-footer {
  text-align: right;
}
/deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {
  width: 15px;
}
.inputWidth185 {
  width: 189px;
}
.inputWidth100 {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/view/insurance/insuranceSysTeamOrder.vue